export const ReviewAdExtension = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'ReviewAdExtension',
    },
  },
};
